import { handleActions } from "redux-actions";

const initialState = {
    user: null,
    loading: true,
    error: null
}

export default handleActions({
    UPDATE_SESSION: (state, action) => {
        console.log("REDUCER UPD SESS", action.payload)
        return {
            ...state,
            user: action.payload.data,
            loading: false,
            error: null
        }
    },
    LOGIN_FAILED: (state, action) => {
        console.log("REDUCER LOG FAILED", action.payload);
        return {
            ...state,
            loading: false,
            user: null,
            error: action.payload.data
        }
    }
}, initialState)